<!-- <ion-header class="header" *ngIf="key == 1">
  <ion-toolbar>
    <ion-title class="color-netral-900">{{'self_pwa_text.address_history_text' | translate}}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="closeModal()">
        <ion-icon name="close" class="font-size-16 m-l-10" style="vertical-align: middle; color: black;"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header> -->

<ion-content class="content" *ngIf="key == 1">
  <div class="current-location-box">

    <div class="top-row">
      <div class="left">
        <ion-icon name="location-outline" class="location-icon "></ion-icon>
        <span class="title">Current Location <span style="color: green;" class="font-size-22 blink">●</span></span>
      </div>

      <div class="close-btn" (click)="closeModal()">
        <ion-icon name="close-outline"></ion-icon>
      </div>
    </div>

    <div class="status">
      <div class="status-title"> {{currentAddress}}</div>
      <div class="status-subtitle">
        {{ currentDate | date:'EEE, dd MMM, yyyy, hh:mm:ss a' }}
      </div>
    </div>

  </div>

  <div class="section latest" style="padding: 0 20px 8px 20px; margin: 10px 0px 0px 0px;"
    *ngIf="isAddressVerificationEnabled">
    <h2 class="inter-medium font-size-17 color-netral-900">{{'self_pwa_text.latest_text' | translate}}</h2>
    <mat-accordion class="dynamic-card-accordian-address">
      <mat-expansion-panel class="expensionPanel" [expanded]="true">
        <mat-expansion-panel-header class="expension_header">
          <mat-panel-title class="mattile inter-medium font-size-13">
            <div fxLayout="column">
              <p class="mattile inter-regular font-size-15 color-netral-900" style="margin-bottom: 5px !important;">
                {{addresses[0].address}}</p>
              <p class="mattile inter-regular font-size-14 color-netral-500" style="margin-bottom: 2px !important;">
                {{addresses[0]?.captureDate | date:'medium' : _appServices.getTimeZoneOffset()}}</p>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <div class="inspection-details" style="background-color: #F4F4F4;">
          <div fxLayout="row" fxLayoutAlign="space-between start" class="w-100" fxLayoutGap="16px">
            <!-- Performed by section -->
            <div fxFlex class="inter-medium font-size-13 color-netral-700" fxLayout="column" style="min-width: 0;">

              <div fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="4px">
                {{ 'self_pwa_text.Performed_by_text' | translate }}
                <span class="inter-medium font-size-13 color-netral-500" style="word-break: break-word;">
                  {{ addresses[0]?.performedBy }}
                  ({{ addresses[0]?.performedBy === 'User' ? addresses[0]?.userId : addresses[0]?.agentId }})
                </span>
              </div>
            </div>

            <!-- Mode section -->
            <div fxFlex="none" class="inter-medium font-size-13 color-netral-700" fxLayout="row" fxLayoutGap="4px"
              fxLayoutAlign="end center">

              Mode:
              <span class="inter-medium font-size-13 color-netral-500">
                {{ addresses[0]?.inspectionModeName[_appSetting.selectedLanguage] }}
              </span>
            </div>
          </div>


          <div fxLayout="row" fxLayoutAlign="space-between center" style="gap:20%">
            <span class="inter-medium font-size-13 color-netral-700">{{'self_pwa_text.Lat_text' | translate}}: <span
                class="inter-medium font-size-13 color-netral-500">{{addresses[0]?.gpsLat ? (addresses[0]?.gpsLat |
                number:'1.6-6') : '-' }}</span></span>
            <span class="inter-medium font-size-13 color-netral-700">{{'self_pwa_text.Long_text' | translate}}: <span
                class="inter-medium font-size-13 color-netral-500">{{addresses[0]?.gpsLng ? (addresses[0]?.gpsLng |
                number:'1.6-6') : '-'}}</span></span>
          </div>
          <div class="performedby" *ngIf="addresses[0].isskip == 1">
            <span class="inter-medium font-size-13 color-netral-700">Last Address:
              <span class="inter-medium font-size-13 color-netral-500">Skip</span></span>
          </div>
          <a [href]="'https://www.google.com/maps?q=' + addresses[0]?.gpsLat + ',' + addresses[0]?.gpsLng"
            target="_blank" rel="noopener noreferrer"
            class="map-link inter-medium font-size-14">{{'common_text.go_to_map_text' | translate}}</a>

          <ion-card class="ion-cards-image" style="background-color: #F4F4F4; margin: 5px 0px 0px 0px;"
            *ngIf="addresses[0].isskip == 0">
            <img [src]=addresses[0]?.imageURL class="h-100 w-100 obj-fit-cover" alt="Inspection Image">
          </ion-card>
        </div>

      </mat-expansion-panel>
    </mat-accordion>
  </div>

  <div class="section previous" style="padding: 0 20px; margin: 10px 0px 0px 0px;"
    *ngIf="addresses?.length > 1 && isAddressVerificationEnabled">
    <h2 class="inter-medium font-size-17 color-netral-900">{{'self_pwa_text.Previous_text' | translate}}</h2>
    <div class="address-card" *ngFor="let add of addresses.slice(1); let i = index">
      <mat-accordion class="dynamic-card-accordian-address">
        <mat-expansion-panel class="expensionPanel">
          <mat-expansion-panel-header class="expension_header">
            <mat-panel-title class="text-black mattile inter-medium font-size-13">
              <div fxLayout="column">
                <p class="mattile color-netral-900 inter-regular font-size-15" style="margin-bottom: 5px !important;">
                  {{add.address}}</p>
                <p class="color-netral-500 mattile inter-regular font-size-14" style="margin-bottom: 2px !important;">
                  {{add?.captureDate | date:'medium' : _appServices.getTimeZoneOffset()}}
                  <span *ngIf="add.isskip == 0" style="    position: absolute;
    right: 2%;top:65%" class="color-netral-900">
                    <ion-icon name="image-outline"></ion-icon>
                  </span>
                </p>
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <div class="inspection-details" style="background-color: #F4F4F4;">

            <div fxLayout="row" fxLayoutAlign="space-between start" fxLayoutGap="20px" class="w-100">
              <!-- Performed by section -->
              <div fxFlex fxLayout="column" class="inter-medium font-size-13 color-netral-700" style="min-width: 0;">

                <div fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="4px">
                  {{ 'self_pwa_text.Performed_by_text' | translate }}
                  <span class="color-netral-500" style="word-break: break-word;">
                    {{ add?.performedBy }}
                    ({{ add?.performedBy === 'User' ? add?.userId : add?.agentId }})
                  </span>
                </div>
              </div>

              <!-- Mode section -->
              <div fxFlex="none" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="4px"
                class="inter-medium font-size-13 color-netral-700">
                Mode:
                <span class="color-netral-500 m-l-5">
                  {{ add?.inspectionModeName[_appSetting.selectedLanguage] }}
                </span>
              </div>
            </div>


            <div fxLayout="row" fxLayoutAlign="space-between center" style="gap:20%">
              <span class="inter-medium font-size-13 color-netral-700">{{'self_pwa_text.Lat_text' | translate}}: <span
                  class="inter-medium font-size-13 color-netral-500">{{add?.gpsLat ? (add.gpsLat | number:'1.6-6') : '-'
                  }}</span></span>
              <span class="inter-medium font-size-13 color-netral-700">{{'self_pwa_text.Long_text' | translate}}: <span
                  class="inter-medium font-size-13 color-netral-500">{{add?.gpsLng ? (add.gpsLng | number:'1.6-6') : '-'
                  }}</span></span>
            </div>
            <div class="performedby" *ngIf="add.isskip == 1">
              <span class="inter-medium font-size-13 color-netral-700">Last Address:
                <span class="inter-medium font-size-13 color-netral-500">Skip</span></span>
            </div>
            <a [href]="'https://www.google.com/maps?q=' + add?.gpsLat + ',' + add?.gpsLng" target="_blank"
              rel="noopener noreferrer" class="map-link inter-medium font-size-14">{{'common_text.go_to_map_text' |
              translate}}</a>

            <ion-card class="ion-cards-image" style="background-color: #F4F4F4; margin: 5px 0px 0px 0px;"
              *ngIf="add.isskip == 0">
              <img [src]=add?.imageURL class="h-100 w-100 obj-fit-cover" alt="Inspection Image">
            </ion-card>
          </div>

        </mat-expansion-panel>
      </mat-accordion>
    </div>


  </div>
</ion-content>


<ion-header class="header" *ngIf="key == 2">
  <ion-toolbar>
    <ion-title>Add Sub Objects</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="closeModal()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="content" *ngIf="key == 2">
  <div class="checkbox-grid">
    <ion-item *ngFor="let item of subObjects" lines="none">
      <ion-checkbox slot="start" [(ngModel)]="item.checked" style="margin-left: 0; margin-right: 10px;"></ion-checkbox>
      <ion-label>{{ item.name }}</ion-label>
    </ion-item>
  </div>
</ion-content>

<ion-footer *ngIf="key == 2">
  <ion-button expand="block" color="primary" (click)="saveSelections()">Save</ion-button>
</ion-footer>



<ion-header class="modal-header" *ngIf="key == 3">
  <ion-toolbar>
    <ion-title>Time Out</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="closeModal()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="modal-content" *ngIf="key == 3">
  <div class="icon-wrapper" style="margin: 5% 0 5% 42%;">
    <ion-img src="../../../assets/images/alert_icon.png"></ion-img> <!-- Add your icon image here -->
  </div>
  <div class="message-text">
    Oops! Look likes your session has timed out to get your location due to slow network issue.
  </div>
</ion-content>

<ion-footer *ngIf="key == 3" style="margin: auto;">
  <div fxLayout="row" fxLayoutAlign="center center" class="m-16-0">
    <ion-button class="commonbtn h-48 m-0 " class="btn-border" style="width: 90%; margin: 0; height: 48px;"
      (click)="tryAgain()">Try
      Again</ion-button>
  </div>
</ion-footer>


<ion-header class="modal-header" *ngIf="key == 4">
  <ion-toolbar>
    <!-- <ion-title class="p-0 m-0 color-netral-900 inter-bold">{{'self_pwa_text.give_permision_text' |
      translate}}</ion-title> -->
    <ion-title class="p-0 m-0 color-netral-900 inter-bold">{{'self_pwa_text.location_not_availble' |
      translate}}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="closeModal()">
        <ion-icon name="close-circle" class="font-size-25 color-netral-900"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ng-container *ngIf="steps; else tryAgainGuide">
  <ion-content class="modal-content" *ngIf="key == 4" #content>
    <ion-card style="text-align: left;
    background: #f4f4f4;
    color: #111111;
    font-weight: 400;
    box-shadow: none !important;
    border-radius: 10px;
    border: 1px solid #EEEEEE;">
      <ion-card-content>
        <div fxLayout="row" fxLayoutAlign="start start" style="gap: 5px;">
          <ion-icon name="alert-circle-outline" style="zoom: 3;
          display: flex;
          color: red !important;
          justify-content: flex-start;
          align-items: flex-start;
          margin-top: -3px;"></ion-icon>
          <h4 class="font-size-15 color-netral-900">{{'self_pwa_text.location_not_detect' | translate}}</h4>
        </div>
      </ion-card-content>
    </ion-card>
    <div class="inspection-cards-container p-0">
      <div class="tab-container">
        <div class="tab font-size-15 color-netral-900 inter-medium" *ngFor="let tab of tabs; let j=index"
          [class.active]="j == selectedTabIndex" (click)="onTabClick(j)">
          {{tab.tabName}}
        </div>
      </div>
    </div>
    <ion-card class="m-0">
      <ion-card-content>
        <div *ngIf="platform === 'android'">
          <div *ngIf="selectedTabIndex == 0">
            <h2 class="font-size-18 ion-text-left color-netral-900 inter-large m-t-15 m-b-10">
              {{'self_pwa_text.enable_location_text' | translate}}</h2>
            <ion-list lines="none" class="b-r-13 m-t-5 b-1">
              <ion-item>
                <ion-icon slot="start" name="settings-outline" class="m-r-10"></ion-icon>
                <ion-label class="show-fulltext color-netral-600 inter-regular">{{'self_pwa_text.open_app_text' |
                  translate}} <strong class="color-netral-800 inter-bold">{{'self_pwa_text.settings_text' |
                    translate}}</strong> {{'self_pwa_text.app_text' | translate}}</ion-label>
              </ion-item>
              <ion-item>
                <ion-icon slot="start" name="location-outline" class="m-r-10"></ion-icon>
                <ion-label class="show-fulltext color-netral-600 inter-regular">{{'self_pwa_text.navigate_text' |
                  translate}} <strong class="color-netral-800 inter-bold">{{'self_pwa_text.location_text' |
                    translate}}</strong> {{'self_pwa_text.or_text' | translate}} <strong
                    class="color-netral-800 inter-bold">{{'self_pwa_text.privacy_text' | translate}}</strong>
                  {{'self_pwa_text.settings_text' | translate}}.</ion-label>
              </ion-item>
              <ion-item>
                <ion-icon slot="start" name="toggle-outline" class="m-r-10"></ion-icon>
                <ion-label class="show-fulltext color-netral-600 inter-regular">{{'self_pwa_text.turn_text' |
                  translate}}
                  <strong class="color-netral-800 inter-bold">{{'self_pwa_text.location_text' | translate}}</strong>
                  {{'self_pwa_text.toggle_text' | translate}}
                  <strong class="color-netral-800 inter-bold"> {{'self_pwa_text.on_text' |
                    translate}}</strong>.</ion-label>
              </ion-item>
              <ion-item>
                <ion-icon slot="start" name="compass-outline" class="m-r-10"></ion-icon>
                <ion-label class="show-fulltext color-netral-600 inter-regular">{{'self_pwa_text.choose_text' |
                  translate}} <strong class="color-netral-800 inter-bold">{{'self_pwa_text.high_accuracy_text' |
                    translate}}</strong> {{'self_pwa_text.prompted_text' |
                  translate}}</ion-label>
              </ion-item>
              <ion-item>
                <ion-icon slot="start" name="arrow-back-outline" class="m-r-10"></ion-icon>
                <ion-label class="show-fulltext color-netral-600 inter-regular">{{'self_pwa_text.return_app_text' |
                  translate}}</ion-label>
              </ion-item>

              <ion-item class="ion-justify-content-center">
                <h4 (click)="toggleGif(0)" style="color: #295396;
    font-size: 15px;"><u>{{ (showGif && index == 0 ? 'self_pwa_text.hide_gif' : 'self_pwa_text.watch_gif') | translate
                    }}</u></h4>
              </ion-item>
              <!-- GIF Image (Hidden Initially) -->
              <ion-item *ngIf="showGif && index == 0" class="ion-justify-content-center">
                <img src="../../../assets/images/PermissioGif/first.gif" alt="Enable Location Guide"
                  class="location-gif">
              </ion-item>
            </ion-list>
          </div>

          <div *ngIf="selectedTabIndex == 1">
            <h2 class="font-size-18 ion-text-left color-netral-900 inter-large m-t-15 m-b-10">
              {{'self_pwa_text.allow_permission_text' |
              translate}}</h2>
            <ion-list lines="none" class="b-r-13 m-t-5 b-1">
              <ion-item>
                <ion-icon slot="start" name="settings-outline" class="m-r-10"></ion-icon>
                <ion-label class="show-fulltext color-netral-600 inter-regular">{{'self_pwa_text.open_app_text' |
                  translate}} <strong class="color-netral-800 inter-bold">{{'self_pwa_text.settings_text' |
                    translate}}</strong> {{'self_pwa_text.app_text' |
                  translate}}</ion-label>
              </ion-item>
              <ion-item>
                <ion-icon slot="start" name="apps-outline" class="m-r-10"></ion-icon>
                <ion-label class="show-fulltext color-netral-600 inter-regular">{{'self_pwa_text.go_to_text' |
                  translate}} <strong class="color-netral-800 inter-bold">{{'self_pwa_text.apps_text' |
                    translate}}</strong> {{'self_pwa_text.or_text' |
                  translate}}
                  <strong class="color-netral-800 inter-bold">{{'self_pwa_text.application_text' |
                    translate}}</strong>.</ion-label>
              </ion-item>
              <ion-item>
                <ion-icon slot="start" name="search-outline" class="m-r-10"></ion-icon>
                <ion-label class="show-fulltext color-netral-600 inter-regular">{{'self_pwa_text.find_app_text' |
                  translate}}</ion-label>
              </ion-item>
              <ion-item>
                <ion-icon slot="start" name="lock-closed-outline" class="m-r-10"></ion-icon>
                <ion-label class="show-fulltext color-netral-600 inter-regular">{{'self_pwa_text.tap_text' |
                  translate}} <strong class="color-netral-800 inter-bold">{{'self_pwa_text.permissions_text' |
                    translate}}</strong>.</ion-label>
              </ion-item>
              <ion-item>
                <ion-icon slot="start" name="locate-outline" class="m-r-10"></ion-icon>
                <ion-label class="show-fulltext color-netral-600 inter-regular">{{'self_pwa_text.enable_text' |
                  translate}} <strong class="color-netral-800 inter-bold">{{'self_pwa_text.location_text' |
                    translate}}</strong>
                  {{'self_pwa_text.permission_text' |
                  translate}}</ion-label>
              </ion-item>
              <ion-item>
                <ion-icon slot="start" name="arrow-back-outline" class="m-r-10"></ion-icon>
                <ion-label class="show-fulltext color-netral-600 inter-regular">{{'self_pwa_text.return_app_text' |
                  translate}}</ion-label>
              </ion-item>
              <ion-item class="ion-justify-content-center">
                <h4 (click)="toggleGif(1)" style="color: #295396;
    font-size: 15px;"><u>{{ (showGif && index == 1 ? 'self_pwa_text.hide_gif' : 'self_pwa_text.watch_gif') | translate
                    }}</u></h4>
              </ion-item>
              <!-- GIF Item -->
              <ion-item *ngIf="showGif && index == 1" class="ion-justify-content-center">
                <!-- <ion-label class="show-fulltext color-netral-600 inter-regular">Follow Gif</ion-label> -->
                <img src="../../../assets/images/PermissioGif/second.gif" alt="Enable Location Guide"
                  class="location-gif">
              </ion-item>
            </ion-list>
          </div>

          <div *ngIf="selectedTabIndex == 2">
            <h2 class="font-size-18 ion-text-left color-netral-900 inter-large m-t-15 m-b-10">
              <span [innerHTML]="highlightWords('self_pwa_text.enableLocationForWebsite' |
            translate)"></span>
            </h2>

            <ion-list lines="none" class="b-r-13 m-t-5 b-1">
              <ion-item>
                <ion-icon slot="start" name="arrow-back-outline" class="m-r-10"></ion-icon>
                <ion-label class="show-fulltext color-netral-600">
                  <span [innerHTML]="highlightWords('self_pwa_text.lookAtLeftSide' |
            translate)"></span>
                </ion-label>
              </ion-item>
              <ion-item>
                <ion-icon slot="start" name="lock-closed-outline" class="m-r-10"></ion-icon>
                <ion-label class="show-fulltext color-netral-600 inter-regular">
                  <span [innerHTML]="highlightWords('self_pwa_text.tapIcon' |
            translate)"></span>
                </ion-label>
              </ion-item>
              <ion-item>
                <ion-icon slot="start" name="toggle-outline" class="m-r-10"></ion-icon>
                <ion-label class="show-fulltext color-netral-600 inter-regular"><span [innerHTML]="highlightWords('self_pwa_text.toggleLocation' |
              translate)"></span></ion-label>
              </ion-item>
              <ion-item class="ion-justify-content-center">
                <h4 (click)="toggleGif(2)" style="color: #295396;
    font-size: 15px;"><u>{{ (showGif && index == 2 ? 'self_pwa_text.hide_gif' : 'self_pwa_text.watch_gif') | translate
                    }}</u></h4>
              </ion-item>
              <!-- GIF Item -->
              <ion-item *ngIf="showGif && index == 2" class="ion-justify-content-center">
                <!-- <ion-label class="show-fulltext color-netral-600 inter-regular">Follow Gif</ion-label> -->
                <img src="../../../assets/images/PermissioGif/third.gif" alt="Enable Location Guide"
                  class="location-gif">
              </ion-item>
            </ion-list>
          </div>
        </div>

        <div *ngIf="platform === 'ios'">
          <ng-container *ngIf="browserType === 'Safari'">
            <div *ngIf="selectedTabIndex == 0">
              <h2 class="font-size-18 ion-text-left inter-large color-netral-900 m-t-15 m-b-10">
                <span [innerHTML]="highlightWords('self_pwa_text.enableLocationSafari' |
            translate)"></span>
              </h2>
              <ion-list lines="none" class="b-r-13 m-t-5 b-1">
                <ion-item>
                  <ion-icon slot="start" name="settings-outline" class="m-r-10"></ion-icon>
                  <ion-label class="show-fulltext color-netral-600">
                    <span [innerHTML]="highlightWords('self_pwa_text.openSettings' |
            translate)"></span>
                  </ion-label>
                </ion-item>
                <ion-item>
                  <ion-icon slot="start" name="lock-closed-outline" class="m-r-10"></ion-icon>
                  <ion-label class="show-fulltext color-netral-600">
                    <span [innerHTML]="highlightWords('self_pwa_text.tapPrivacySecurity' |
            translate)"></span>
                  </ion-label>
                </ion-item>
                <ion-item>
                  <ion-icon slot="start" name="location-outline" class="m-r-10"></ion-icon>
                  <ion-label class="show-fulltext color-netral-600">
                    <span [innerHTML]="highlightWords('self_pwa_text.tapLocationServices' |
            translate)"></span>
                  </ion-label>
                </ion-item>
                <ion-item>
                  <ion-icon slot="start" name="globe-outline" class="m-r-10"></ion-icon>
                  <ion-label class="show-fulltext color-netral-600">
                    <span [innerHTML]="highlightWords('self_pwa_text.selectSafariWebsites' |
            translate)"></span>
                  </ion-label>
                </ion-item>
                <ion-item>
                  <ion-icon slot="start" name="checkmark-circle-outline" class="m-r-10"></ion-icon>
                  <ion-label class="show-fulltext color-netral-600">
                    <span [innerHTML]="highlightWords('self_pwa_text.chooseLocationOption' |
            translate)"></span>
                  </ion-label>
                </ion-item>
                <ion-item class="ion-justify-content-center">
                  <h4 (click)="toggleGif(0)" style="color: #295396;
    font-size: 15px;"><u>{{ (showGif && index == 0 ? 'self_pwa_text.hide_gif' : 'self_pwa_text.watch_gif') | translate
                      }}</u></h4>
                </ion-item>
                <!-- GIF Item -->
                <ion-item *ngIf="showGif && index == 0" class="ion-justify-content-center">
                  <!-- <ion-label class="show-fulltext color-netral-600 inter-regular">Follow Gif</ion-label> -->
                  <img src="../../../assets/images/PermissioGif/fourth.gif" alt="Enable Location Guide"
                    class="location-gif">
                </ion-item>
              </ion-list>
            </div>
            <div *ngIf="selectedTabIndex == 1">
              <h2 class="font-size-18 ion-text-left inter-large color-netral-900 m-t-15 m-b-10">
                <span [innerHTML]="highlightWords('self_pwa_text.enableLocationForWebsite' |
            translate)"></span>
              </h2>
              <ion-list lines="none" class="b-r-13 m-t-5 b-1">
                <ion-item>
                  <ion-icon slot="start" name="globe-outline" class="m-r-10"></ion-icon>
                  <ion-label class="show-fulltext color-netral-600">
                    <span [innerHTML]="highlightWords('self_pwa_text.openSafariWebsite' |
                translate)"></span>
                  </ion-label>
                </ion-item>
                <ion-item>
                  <ion-icon slot="start" name="text-outline" class="m-r-10"></ion-icon>
                  <ion-label class="show-fulltext color-netral-600 ">
                    <span [innerHTML]="highlightWords('self_pwa_text.tapAAIcon' |
                translate)"></span>
                  </ion-label>
                </ion-item>
                <ion-item>
                  <ion-icon slot="start" name="settings-outline" class="m-r-10"></ion-icon>
                  <ion-label class="show-fulltext color-netral-600 ">
                    <span [innerHTML]="highlightWords('self_pwa_text.selectWebsiteSettings' |
                translate)"></span>
                  </ion-label>
                </ion-item>
                <ion-item>
                  <ion-icon slot="start" name="location-outline" class="m-r-10"></ion-icon>
                  <ion-label class="show-fulltext color-netral-600">
                    <span [innerHTML]="highlightWords('self_pwa_text.tapLocationAllow' |
                translate)"></span>
                  </ion-label>
                </ion-item>
                <ion-item>
                  <ion-icon slot="start" name="refresh-outline" class="m-r-10"></ion-icon>
                  <ion-label class="show-fulltext color-netral-600">
                    <span [innerHTML]="highlightWords('self_pwa_text.reloadPage' |
                translate)"></span>
                  </ion-label>
                </ion-item>
                <ion-item class="ion-justify-content-center">
                  <h4 (click)="toggleGif(1)" style="color: #295396;
    font-size: 15px;"><u>{{ (showGif && index == 1 ? 'self_pwa_text.hide_gif' : 'self_pwa_text.watch_gif') | translate
                      }}</u></h4>
                </ion-item>
                <!-- GIF Item -->
                <ion-item *ngIf="showGif && index == 1" class="ion-justify-content-center">
                  <!-- <ion-label class="show-fulltext color-netral-600 inter-regular">Follow Gif</ion-label> -->
                  <img src="../../../assets/images/PermissioGif/fifth.gif" alt="Enable Location Guide"
                    class="location-gif">
                </ion-item>
              </ion-list>
            </div>
            <div *ngIf="selectedTabIndex == 2">
              <h2 class="font-size-18 ion-text-left inter-large color-netral-900 m-t-15 m-b-10">
                Allow Browser Location
              </h2>
              <ion-list lines="none" class="b-r-13 m-t-5 b-1">
                <ion-item>
                  <ion-icon slot="start" name="settings-outline" class="m-r-10"></ion-icon>
                  <ion-label class="show-fulltext color-netral-600">
                    <span [innerHTML]="highlightWords('self_pwa_text.openSettings' |
                translate)"></span>
                  </ion-label>
                </ion-item>
                <ion-item>
                  <ion-icon slot="start" name="apps-outline" class="m-r-10"></ion-icon>
                  <ion-label class="show-fulltext color-netral-600 ">
                    <span [innerHTML]="highlightWords('self_pwa_text.click_on_apps' |
                translate)"></span>
                  </ion-label>
                </ion-item>
                <ion-item>
                  <ion-icon slot="start" name="globe-outline" class="m-r-10"></ion-icon>
                  <ion-label class="show-fulltext color-netral-600 ">
                    <span [innerHTML]="highlightWords('self_pwa_text.click_on_safari' |
                translate)"></span>
                  </ion-label>
                </ion-item>
                <ion-item>
                  <ion-icon slot="start" name="location-outline" class="m-r-10"></ion-icon>
                  <ion-label class="show-fulltext color-netral-600">
                    <span [innerHTML]="highlightWords('self_pwa_text.click_on_location' |
                translate)"></span>
                  </ion-label>
                </ion-item>
                <ion-item>
                  <ion-icon slot="start" name="location-outline" class="m-r-10"></ion-icon>
                  <ion-label class="show-fulltext color-netral-600">
                    <span [innerHTML]="highlightWords('self_pwa_text.allow_location_if_denied' |
                translate)"></span>
                  </ion-label>
                </ion-item>
                <ion-item>
                  <ion-icon slot="start" name="refresh-outline" class="m-r-10"></ion-icon>
                  <ion-label class="show-fulltext color-netral-600">
                    <span [innerHTML]="highlightWords('self_pwa_text.reloadPage' |
                translate)"></span>
                  </ion-label>
                </ion-item>

                <ion-item class="ion-justify-content-center">
                  <h4 (click)="toggleGif(2)" style="color: #295396;
    font-size: 15px;"><u>{{ (showGif && index == 2 ? 'self_pwa_text.hide_gif' : 'self_pwa_text.watch_gif') | translate
                      }}</u></h4>
                </ion-item>
                <!-- GIF Item -->
                <ion-item *ngIf="showGif && index == 2" class="ion-justify-content-center">
                  <!-- <ion-label class="show-fulltext color-netral-600 inter-regular">Follow Gif</ion-label> -->
                  <img src="../../../assets/images/PermissioGif/seven.gif" alt="Enable Location Guide"
                    class="location-gif">
                </ion-item>
              </ion-list>
            </div>
          </ng-container>

          <ng-container *ngIf="browserType === 'Chrome'">
            <div *ngIf="selectedTabIndex == 0">
              <h2 class="font-size-18 ion-text-left color-netral-900 inter-large  m-t-15 m-b-10">
                <span [innerHTML]="highlightWords('self_pwa_text.enableLocationChrome' |
                translate)"></span>
              </h2>
              <ion-list lines="none" class="b-r-13 m-t-5 b-1">
                <ion-item>
                  <ion-icon slot="start" name="settings-outline" class="m-r-10"></ion-icon>
                  <ion-label class="show-fulltext color-netral-600">
                    <span [innerHTML]="highlightWords('self_pwa_text.openSettings' |
                translate)"></span>
                  </ion-label>
                </ion-item>
                <ion-item>
                  <ion-icon slot="start" name="location-outline" class="m-r-10"></ion-icon>
                  <ion-label class="show-fulltext color-netral-600">
                    <span [innerHTML]="highlightWords('self_pwa_text.tapPrivacySecurityLocation' |
                translate)"></span>
                  </ion-label>
                </ion-item>
                <ion-item>
                  <ion-icon slot="start" name="logo-chrome" class="m-r-10"></ion-icon>
                  <ion-label class="show-fulltext color-netral-600">
                    <span [innerHTML]="highlightWords('self_pwa_text.selectGoogleChrome' |
                translate)"></span>
                  </ion-label>
                </ion-item>
                <ion-item>
                  <ion-icon slot="start" name="checkmark-circle-outline" class="m-r-10"></ion-icon>
                  <ion-label class="show-fulltext color-netral-600">
                    <span [innerHTML]="highlightWords('self_pwa_text.chooseLocationOptionChrome' |
                translate)"></span>
                  </ion-label>
                </ion-item>
                <ion-item class="ion-justify-content-center">
                  <h4 (click)="toggleGif(1)" style="color: #295396;
    font-size: 15px;"><u>{{ (showGif && index == 1 ? 'self_pwa_text.hide_gif' : 'self_pwa_text.watch_gif') | translate
                      }}</u></h4>
                </ion-item>
                <!-- GIF Item -->
                <ion-item *ngIf="showGif && index == 1" class="ion-justify-content-center">
                  <!-- <ion-label class="show-fulltext color-netral-600 inter-regular">Follow Gif</ion-label> -->
                  <img src="../../../assets/images/PermissioGif/sixth.gif" alt="Enable Location Guide"
                    class="location-gif">
                </ion-item>
              </ion-list>
            </div>
          </ng-container>

          <ng-container *ngIf="browserType !== 'Safari' && browserType !== 'Chrome'">
            <h2 class="font-size-18 ion-text-left color-netral-900 inter-large m-t-15 m-b-10">
              <span [innerHTML]="highlightWords('self_pwa_text.enableLocationIphone' |
                translate)"></span>
            </h2>
            <ion-list lines="none" class="b-r-13 m-t-5 b-1">
              <ion-item>
                <ion-icon slot="start" name="settings-outline" class="m-r-10"></ion-icon>
                <ion-label class="show-fulltext color-netral-600 inter-regular">
                  <span [innerHTML]="highlightWords('self_pwa_text.openSettings' |
                translate)"></span>
                </ion-label>
              </ion-item>
              <ion-item>
                <ion-icon slot="start" name="location-outline" class="m-r-10"></ion-icon>
                <ion-label class="show-fulltext color-netral-600">
                  <span [innerHTML]="highlightWords('self_pwa_text.tapPrivacySecurityLocation' |
                translate)"></span>
                </ion-label>
              </ion-item>
              <ion-item>
                <ion-icon slot="start" name="checkmark-circle-outline" class="m-r-10"></ion-icon>
                <ion-label class="show-fulltext color-netral-600">
                  <span [innerHTML]="highlightWords('self_pwa_text.ensureLocationServicesOn' |
                translate)"></span>
                </ion-label>
              </ion-item>
              <ion-item>
                <ion-icon slot="start" name="refresh-outline" class="m-r-10"></ion-icon>
                <ion-label class="show-fulltext color-netral-600">
                  <span [innerHTML]="highlightWords('self_pwa_text.restartDeviceIfNotWorking' |
                translate)"></span>
                </ion-label>
              </ion-item>
            </ion-list>
          </ng-container>
        </div>
        <div *ngIf="platform === 'unknown'">
          <p class="show-fulltext ion-text-left color-netral-600 inter-regular">{{'self_pwa_text.for_unknown_text' |
            translate}}
          </p>
        </div>
      </ion-card-content>
    </ion-card>
  </ion-content>
  <ion-footer *ngIf="key == 4" style="margin: auto;">
    <div fxLayout="row" fxLayoutAlign="center center" class="m-8-16">
      <ion-button expand="block"
        class="t-c commonbtn show-fulltext h-48 w-100 font-size-18 inter-medium letter-spacing-normal"
        (click)="checkNow()">
        {{'self_pwa_text.check_now' | translate}}
      </ion-button>
    </div>
  </ion-footer>
</ng-container>
<ng-template #tryAgainGuide>
  <ion-content class="modal-content" *ngIf="key == 4">
    <ion-card style="text-align: left;
    background: #f4f4f4;
    color: #111111;
    font-weight: 400;
    box-shadow: none !important;
    border-radius: 10px;
    border: 1px solid #EEEEEE;">
      <ion-card-content>
        <div fxLayout="row" fxLayoutAlign="start start" style="gap: 5px;">
          <ion-icon name="alert-circle-outline" style="zoom: 3;
          display: flex;
          color: red !important;
          justify-content: flex-start;
          align-items: flex-start;
          margin-top: -3px;"></ion-icon>
          <h4 class="font-size-15 color-netral-900">
            <span [innerHTML]="highlightWords('self_pwa_text.tried_all_steps' |
                translate)"></span>
          </h4>
        </div>
      </ion-card-content>
    </ion-card>
    <ion-card class="m-0" style="box-shadow: none;">
      <ion-card-content>
        <ion-list lines="none" class="b-r-13 m-t-5 b-1">
          <ion-item>
            <ion-icon slot="start" class="m-r-10" name="refresh-outline"></ion-icon>
            <ion-label class="show-fulltext color-netral-600 inter-regular">{{'self_pwa_text.you_can' | translate}}<span
                class="tryagain" (click)="tryagainpreviousstep()" class="spanarea"><u> {{'self_pwa_text.try_again' |
                  translate}}</u></span> {{'self_pwa_text.previous_steps' | translate}}</ion-label>
          </ion-item>
          <ion-item>
            <ion-icon slot="start" class="m-r-10" name="refresh-outline"></ion-icon>
            <ion-label class="show-fulltext color-netral-600 inter-regular"><span [innerHTML]="highlightWords('self_pwa_text.try_to_refresh_page_text' |
              translate)"></span></ion-label>
          </ion-item>
          <ion-item>
            <ion-icon slot="start" class="m-r-10" name="link-outline"></ion-icon>
            <ion-label class="show-fulltext color-netral-600 inter-regular"><span [innerHTML]="highlightWords('self_pwa_text.use_different_browser' |
              translate)"></span></ion-label>
          </ion-item>
          <ion-item>
            <ion-icon slot="start" class="m-r-10" name="phone-portrait-outline"></ion-icon>
            <ion-label class="show-fulltext color-netral-600 inter-regular"><span [innerHTML]="highlightWords('self_pwa_text.use_different_device' |
              translate)"></span></ion-label>
          </ion-item>
          <ion-item>
            <ion-icon slot="start" class="m-r-10" name="headset-outline"></ion-icon>
            <ion-label class="show-fulltext color-netral-600 inter-regular"><span [innerHTML]="highlightWords('self_pwa_text.contact_agent' |
              translate)"></span></ion-label>
          </ion-item>
        </ion-list>
      </ion-card-content>
    </ion-card>
  </ion-content>
  <ion-footer style="margin: auto;">
    <div fxLayout="row" fxLayoutAlign="center center" class="m-8-16">
      <ion-button expand="block"
        class="t-c commonbtn show-fulltext h-48 w-100 font-size-18 inter-medium letter-spacing-normal"
        (click)="Refresh()">
        {{'self_pwa_text.refresh_now' |
        translate}}
      </ion-button>
    </div>
  </ion-footer>
</ng-template>